import React, { SVGProps, useMemo } from 'react'
//import 'ladder/ux/icon2.css' // defstyles macro still in play, we're compatible

interface IconProps extends SVGProps<SVGSVGElement> {
    icon: [string, Record<string, any>, React.ReactNode]; // [fileName, attrs, contents]
    color?: string; // keyword("medium-gray")
    noStroke?: boolean;
    alt?: string;
    defaultColor?: boolean;
}

export const Icon: React.FC<IconProps> = ({icon, color, noStroke, alt, defaultColor, className, ...props}) => {
    let [fileName, attrs, contents] = icon;
    let color2 = useMemo(() => {
        if (defaultColor) { return undefined; }
        if (color && noStroke) { return `${color}-no-stroke`; }
        return color;
    }, [color, noStroke, defaultColor]);
    let idPrefix = useMemo(() => { return `${fileName}-${Math.random().toString(36).substr(2, 9)}`; }, [fileName]); // (str (gensym file-name))
    let hasAlt = !!alt;
    let baseAttrs = useMemo(() => {
        return {
            ...attrs,
            ...(hasAlt ?
                { role: 'img', ariaLabelledby: idPrefix } : // check case vs aria-labelledby
                { role: 'presentation', ariaHidden: 'true' }),
            ...props,
            className: `${className ?? ""} ladder_ux_icon__styles__${color2}`
        }}, [attrs, hasAlt, idPrefix, props, color2]);


    return <svg {...baseAttrs}>
        {hasAlt && <title id={idPrefix}>{alt}</title>}
        {contents}
    </svg>;
};
